import { useContext, useEffect, useState } from "react";
import GinaTemplate from "./gina_template";
import { replaceWord } from "./gina_helper";
import wording from "./gina_message";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

import NewDashboardContext from "../../contexts/NewDashboardContext";

function GinaCore() {
  const { username } = useAuth();
  const location = useLocation();
  const [callout, setCallout] = useState("");
  const [content, setContent] = useState("");
  const [action, setAction] = useState("");
  const [tableContent, setTableContent] = useState([]);
  const [loading, setLoading] = useState(false);
  const [maximize, setMaximize] = useState(false);
  const [viewTable, setViewTable] = useState(false);
  const {
    ginaPosition,
    ginaAction,
    updateGinaAction,
    selectedMachine,
    listGinaAction,
    updateListGinaAction,
    locations,
    updateLocations,
  } = useContext(NewDashboardContext);
  const MINUTE_MS = 60000;

  useEffect(() => {
    if (ginaPosition === "exit_detail") {
      setMaximize(false);
      updateGinaAction({
        action: "",
        callout: wording.checking,
        content: wording.checking,
        loading: true,
      });
      setTimeout(() => {}, 2500);
    }
    if (ginaPosition === "under_construction") {
      updateGinaAction({
        action: "",
        callout: wording.under_construction,
        content: wording.under_construction,
        loading: false,
      });
    }
    if (ginaPosition === "enter_detail") {
      setTimeout(() => {
        let word = replaceWord(wording.alert_detail, {
          machine: selectedMachine.machineName,
          severity: "Critical",
        });
        setMaximize(true);
        updateGinaAction({
          action: "",
          callout: word,
          content: word,
          loading: false,
        });
      }, 500);
    }
    if (ginaPosition === "submitted") {
      const callout = replaceWord(wording.knowledge_inputed, { username });
      updateGinaAction({
        event: "knowledge",
        action: "",
        callout: callout,
        content: callout,
        loading: false,
      });
    }
  }, [ginaPosition]);

  useEffect(() => {
    if (ginaAction) {
      setAction(ginaAction["action"]);
      setCallout(ginaAction["callout"]);
      setContent(ginaAction["content"]);
      setLoading(ginaAction["loading"]);
      const table = !!ginaAction["viewTable"];
      setViewTable(table);
      if (table) {
        setTableContent(ginaAction["tableContent"]);
      } else {
        setTableContent([]);
      }
      if (ginaAction["event"]) {
      }
    }
  }, [ginaAction]);

  useEffect(() => {
    setTimeout(() => {
      let greeting = replaceWord(wording.greeting_checking, { username });
      setCallout(() => greeting);
      setContent(() => greeting);
      setLoading(true);
    }, 2000);
  }, []);
  return (
    <>
      <GinaTemplate
        maximize={maximize}
        viewTable={viewTable}
        tableContent={tableContent}
        action={action}
        callout={callout}
        loading={loading}
      ></GinaTemplate>
    </>
  );
}

export default GinaCore;
